// (c) chaehongee. Confidential and proprietary.

import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'

export interface GenerationParamsState {
    prompt_strength: number
    num_outputs: number
    num_inference_steps: number
    guidance_scale: number
    aspect_ratio: string
    resolution: string
    model: string
}

const initialState: GenerationParamsState = {
    prompt_strength: 0.55,
    num_outputs: 1,
    num_inference_steps: 28,
    guidance_scale: 3,
    aspect_ratio: 'auto',
    resolution: '1K',
    model: 'gpt_image_generate',
}

const generationSlice = createSlice({
    name: 'generationParams',
    initialState,
    reducers: {
        setPromptStrength(state, action: PayloadAction<number>) {
            state.prompt_strength = action.payload
        },
        setNumOutputs(state, action: PayloadAction<number>) {
            state.num_outputs = action.payload
        },
        setNumInferenceSteps(state, action: PayloadAction<number>) {
            state.num_inference_steps = action.payload
        },
        setGuidanceScale(state, action: PayloadAction<number>) {
            state.guidance_scale = action.payload
        },
        setAspectRatio(state, action: PayloadAction<string>) {
            state.aspect_ratio = action.payload
        },
        setResolution(state, action: PayloadAction<string>) {
            state.resolution = action.payload
        },
        setModel(state, action: PayloadAction<string>) {
            state.model = action.payload
        },
        setAll(state, action: PayloadAction<Partial<GenerationParamsState>>) {
            Object.assign(state, action.payload)
        },
        resetDefaults() {
            return initialState
        },
    },
})

export const {
    setPromptStrength,
    setNumOutputs,
    setNumInferenceSteps,
    setGuidanceScale,
    setAspectRatio,
    setResolution,
    setModel,
    setAll,
    resetDefaults,
} = generationSlice.actions

export const selectGenerationParams = (s: RootState) => s.generationParams

export default generationSlice.reducer


